export default __webpack_public_path__ + "static/media/trolley.1ec8f892.png";